
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import ValueProposition from '../../components/feature/ValueProposition';
import Features from '../../components/feature/Features';
import Integrations from '../../components/feature/Integrations';
import Pricing from '../../components/feature/Pricing';
import CTA from '../../components/feature/CTA';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ValueProposition />
      <Features />
      <Integrations />
      <Pricing />
      <CTA />
      <Footer />
    </div>
  );
}
